import warrantyPlanDetailsLink from "./warrantyPlanDetailsLink";

/**
 * Handles common tasks for the recommended accessory (add-ons) pop-up for single
 * item scenarios (product page and cart head unit/speaker just added page).
 * @namespace
 */
const responsiveAccessoryPopupSingle = {
	/**
	 * Tracks whether the images for recommended accessories have already been loaded.
	 * @type {Bool}
	 */
	accessoryImagesLoaded: false,
	/**
	 * Used for Facebook pixel tracking.
	 * @type {Array}
	 */
	facebook_content_ids: [],
	/**
	 * Used for Facebook pixel tracking.
	 * @type {Array}
	 */
	facebook_tracked_item_ids: [],
	/**
	 * Keeps track of cart item IDs for products added to the cart.
	 * @type {Object} The cart item IDs indexed by the product IDs.
	 */
	itemsAddedToCart: {},
	/**
	 * Initializes all event listeners for the accessory pop-up. Init is executed on document ready.
	 * @returns {undefined}
	 */
	init: function() {
		let cartItemId = $('#cart_item_id'),
			productNeedingAccessories = $('#product-needing-accessories');

		if (cartItemId.length && productNeedingAccessories.length) {
			this.itemsAddedToCart[productNeedingAccessories.val()] = cartItemId.val();
		}

		this.warrantyController();

		warrantyPlanDetailsLink();

		$(document.body).on('click', '.addAcessory', function(event) {
			event.preventDefault();

			let $this = $(this),
				itemId = $this.data('accessoryId'),
				addItemBadge = $this.closest('.productContainer').find('.addItemBadge');
			if(window.innerWidth >= 992)
			{
				if ($this.hasClass('added')) {
					responsiveAccessoryPopupSingle.removeItemFromCart(itemId);
					$this.closest('.price').find('.inCartText').addClass('d-none');
					$this.removeClass('added').addClass('remove');
					$this.find('span').removeClass('btn-secondary').addClass('btn-primary');
					addItemBadge.hide();
				} else {
					responsiveAccessoryPopupSingle.addItemToCart([itemId], {});
					$this.closest('.price').find('.inCartText').removeClass('d-none').text('In cart');
					$this.addClass('added').removeClass('remove');
					$this.find('span').addClass('btn-secondary').removeClass('btn-primary').html('Remove');
					addItemBadge.show();
				}
			}
			else
			{
				if ($this.hasClass('added')) {
					responsiveAccessoryPopupSingle.removeItemFromCart(itemId);
					$this.closest('.price').find('.inCartText').addClass('d-none');
					$this.removeClass('added').addClass('remove');
					$this.find('.bi-cart-dash-fill').hide();
					$this.find('.bi-cart-plus-fill').show();
					addItemBadge.hide();
				} else {
					responsiveAccessoryPopupSingle.addItemToCart([itemId], {});
					$this.closest('.price').find('.inCartText').removeClass('d-none').text('In cart');
					$this.find('.bi-cart-plus-fill').hide();
					$this.find('.bi-cart-dash-fill').show();
					$this.addClass('added').removeClass('remove');
					addItemBadge.show();
				}
			}
		});

		$(document.body).on('click', '#extended-warranty-offers-popup-container .extended-offer-checkbox', function() {
			let $this = $(this),
				warrantyId = $this.data('id'),
				planDetailsUrl = $this.data('planDetailsUrl');

			if ($this.hasClass('added')) {
				responsiveAccessoryPopupSingle.removeItemFromCart(warrantyId);
				$this.removeClass('added');
			} else {
				let warArray = {},
					relatedCartItemId = responsiveAccessoryPopupSingle.itemsAddedToCart[$('#product-needing-accessories').val()];
				warArray[relatedCartItemId] = warrantyId;
				responsiveAccessoryPopupSingle.addItemToCart([], warArray);
				$this.addClass('added');
			}

			$('#extended-offer-cards').find('.extended-offer-checkbox').not($this).each(function() {
				let extendedOfferCheckbox = $(this);

				if (extendedOfferCheckbox.hasClass('added')){
					responsiveAccessoryPopupSingle.removeItemFromCart(extendedOfferCheckbox.data('id'));
					extendedOfferCheckbox.removeClass('added');
				}
			});

			if (planDetailsUrl) {
				$('.extended-warranty-offers-inner-container .plan-details-link').attr('href', planDetailsUrl);
			}
		});
	},
	/**
	 * Adds an item, accessory or warranty to the cart.
	 * @param {Array} items List of product IDs to add to the cart
	 * @param {String} extended_warranty Warranty product ID to add to the cart.
	 * @param {Number} quantity
	 * @param {String} redeemedCode Coupon code to redeem.
	 * @returns {undefined}
	 */
	addItemToCart: function(items, extended_warranty, quantity, redeemedCode) {
		let $loading = $('#acessory-lightbox-title'),
			$addOnAccessoryCount = $('#accessory_add_ons_count'),
			$addedAddOnsTotal = $('#addedAddOnsTotal'),
			$selectedWarrantyLabel = $('#warrantyStatus'),
			text = '',
			i = 0,
			setTimeOutId = setInterval(function() {
				i = ++i % 4;
				$loading.html(text + Array(i + 1).join('.') + Array(4 - i).join('&nbsp;'));
			}, 250),
			canSendFacebookTrackingRequest;

		$.ajax({
			url: "/cart/addMultiple",
			type: "POST",
			dataType: "json",
			data: {
				format: "json",
				products: items,
				extended_warranty: extended_warranty,
				quantity: quantity,
				redeemedCode: redeemedCode
			},
			success: function(data) {
				if (data && data.products) {
					$.each(data.products, function(key, item) {
						responsiveAccessoryPopupSingle.itemsAddedToCart[key] = item.cartItemID;

						// Facebook pixel
						if ($.inArray(key, responsiveAccessoryPopupSingle.facebook_tracked_item_ids) > -1) {
							canSendFacebookTrackingRequest = false;
						} else {
							canSendFacebookTrackingRequest = true;
							responsiveAccessoryPopupSingle.facebook_content_ids.push(key);
							responsiveAccessoryPopupSingle.facebook_tracked_item_ids.push(key);
						}
					});

					let selectedAddOns = $('.addOnItem.addAcessory.added'),
						selectedWarranty = $('#extended-offer-cards .extended-offer-checkbox:checked'),
						addedProductsCount = selectedAddOns.length + selectedWarranty.length;

					$addOnAccessoryCount.val(addedProductsCount);
					clearInterval(setTimeOutId);

					// Add total count and sum of selected Add-Ons
					if ($addedAddOnsTotal.length) {
						let $addOnCount = $('#addOnCount'),
							$addedAddOnsSum = $('#addOnTotal'),
							sum = 0;

						if (selectedAddOns.length > 0) {
							// Count.
							$addOnCount.html(selectedAddOns.length > 0 ? (selectedAddOns.length + (selectedAddOns.length === 1 ? ' add-on added for:' : ' add-ons added for:')) : '');
							$.each(selectedAddOns, function() {
								sum += parseFloat($(this).data('accessoryPrice'));
							});
							// Sum.
							$addedAddOnsSum.html(selectedAddOns.length > 0 ? ' $' + sum.toFixed(2) : '');
						} else {
							$addOnCount.html('');
							$addedAddOnsSum.html('');
						}
					}
					if ($selectedWarrantyLabel.length) {
						if (selectedWarranty.length > 0) {
							let sum = 0;

							$.each(selectedWarranty, function() {
								sum += parseFloat($(this).data('price'));
							});
							$selectedWarrantyLabel.html('<span style="font-weight: normal;">' + selectedWarranty.length  + ' warrant' + (selectedWarranty.length === 1 ? 'y' : 'ies') + ' added for:</span> $' + (sum));
							$selectedWarrantyLabel.show();
						} else {
							$selectedWarrantyLabel.hide();
						}
					}
					if (addedProductsCount > 0) {
						$addedAddOnsTotal.removeClass('d-none');
					}

					// Facebook pixel
					if (canSendFacebookTrackingRequest) {
						let facebookPixelParameters = {
							content_type: 'product',
							content_ids: responsiveAccessoryPopupSingle.facebook_content_ids
						};

						// GTM event fire
						dataLayer = dataLayer || [];
						dataLayer.push({'event': 'addedToCart', 'facebookPixelParameters': facebookPixelParameters});
					}
				}
			}
		});
	},
	/**
	 * Removes an item, accessory or warranty from the cart.
	 * @param {String} item The ID of the product that should be removed.
	 * @returns {undefined}
	 */
	removeItemFromCart: function(item) {
		let $loading = $('#acessory-lightbox-title'),
			$addOnAccessoryCount = $('#accessory_add_ons_count'),
			$addedAddOnsTotal = $('#addedAddOnsTotal'),
			$selectedWarrantyLabel = $('#warrantyStatus'),
			text = '',
			i = 0,
			setTimeOutId = setInterval(function() {
				i = ++i % 4;
				$loading.html(text + Array(i+1).join(".") + Array(4-i).join("&nbsp;"));
			}, 250);

		$.ajax({
			url: "/cart/update",
			type: "POST",
			dataType: "json",
			data: {
				format: "json",
				remove_selected: true,
				delete: [responsiveAccessoryPopupSingle.itemsAddedToCart[item]]
			},
			success: function(data) {
				if (data && data.deleteCount) {
					clearInterval(setTimeOutId);

					let selectedAddOns = $('.addOnItem.addAcessory.added'),
						selectedWarranty = $('#extended-offer-cards .extended-offer-checkbox:checked'),
						addedProductsCount = selectedAddOns.length + selectedWarranty.length;

					$addOnAccessoryCount.val(addedProductsCount);
					$loading.html(data.deleteCount + (data.deleteCount === 1 ? ' add-on was' : ' add-ons were') + ' removed from your cart');

					// Add total count and sum of selected Add-Ons
					if (addedProductsCount < 1) {
						$addedAddOnsTotal.addClass('d-none');
					}
					if ($addedAddOnsTotal.length) {
						let $addOnCount = $('#addOnCount'),
							$addedAddOnsSum = $('#addOnTotal'),
							sum = 0;

						if (selectedAddOns.length > 0) {
							// Count.
							$addOnCount.html(selectedAddOns.length + (selectedAddOns.length === 1 ? ' add-on added for:' : ' add-ons added for:'));
							$.each(selectedAddOns, function() {
								sum += parseFloat($(this).data('accessoryPrice'));
							});
							// sum
							$addedAddOnsSum.html(' $' + sum.toFixed(2));
						} else {
							$addOnCount.html('');
							$addedAddOnsSum.html('');
						}
					}
					if ($selectedWarrantyLabel.length) {
						if (selectedWarranty.length > 0) {
							let sum = 0;

							$.each(selectedWarranty, function() {
								sum += parseFloat($(this).data('price'));
							});
							$selectedWarrantyLabel.html('<span style="font-weight: normal;">' + selectedWarranty.length  + ' warrant' + (selectedWarranty.length === 1 ? 'y' : 'ies') + ' added for:</span> $' + (sum));
							$selectedWarrantyLabel.show();
						} else {
							$selectedWarrantyLabel.hide();
						}
					}

					// Facebook pixel
					let index = responsiveAccessoryPopupSingle.facebook_content_ids.indexOf(item);

					if (index > -1) {
						responsiveAccessoryPopupSingle.facebook_content_ids.splice(index, 1);
					}
				}
			}
		});
	},
	/**
	 * Creates a checkbox list for the extended warranty options.
	 * On checkbox change:
	 *   - Updates product price
	 *   - Adds/removes 'with warranty' text following price
	 * @returns {undefined}
	 */
	warrantyController: function() {
		let extendedOfferCards = $('#extended-offer-cards'),
			extendedOfferCheckboxes = extendedOfferCards.find('.extended-offer-checkbox'),
			warrantyIdInput = $('#selected-extended-warranty-id');

		extendedOfferCheckboxes.on('change', function() {
			let $this = $(this);

			extendedOfferCheckboxes.not(this).prop('checked', false);
			if ($this.is(':checked')) {
				$this.closest('.extended-offer-card').addClass('checked');
				extendedOfferCheckboxes.not(this).closest('.extended-offer-card').removeClass('checked');
			} else {
				$this.closest('.extended-offer-card').removeClass('checked');
			}

			if (warrantyIdInput.length > 0) {
				let warrantyId = $this.data('id'),
					warrantyPrice = $this.data('price'),
					withWarrantyText = $('#with-warranty-text');

				window.responsiveProduct.withWarrantyPrice(warrantyPrice, $this.is(':checked'));
				if (warrantyIdInput.val() == warrantyId) {
					warrantyIdInput.val('0');
					withWarrantyText.removeClass('active').data('price', '');
				} else {
					warrantyIdInput.val(warrantyId);
					withWarrantyText.addClass('active').data('price', warrantyPrice);
				}
			}
		});
	}
};

export default responsiveAccessoryPopupSingle;
